<template>
  <b-modal
      ref="reatribute-kanban"
      hide-footer
      :title="'Réatributer la carte Kanban ' + card"
      size="lg"
  >
    <div class="d-block">
      <b-container fluid>
        <div class="tab"> 
          <b-row>
            <b-col sm="3">
              <label>Fournisseur interne</label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text"
                v-model="form.internal_supplier"
                :placeholder="supplier"
                :formatter="formatter"
                maxlength="4"
            ></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="3">
              <label>Client interne</label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text"
                v-model="form.internal_customer"
                :placeholder="customer"
                :formatter="formatter"
                maxlength="4"
            ></b-form-input>
            </b-col>
          </b-row>
        </div>
        <hr>
        <div style="overflow:auto;">
          <div style="float:right;">
            <b-button
              class="mt-3"
              variant="info"
              id="nextBtn"
              :disabled="(this.isEmpty(this.form.internal_supplier) || this.isEmpty(this.form.internal_customer))"
              @click="save()"
            >
              Enregistrer
            </b-button>
          </div>
        </div>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'

export default {
  name: 'ReatributionFormModal',
  props: ['customer', 'supplier', 'card', 'office'],
  data() {
    return {
      loading: false,
      form:{
        internal_customer: '',
        internal_supplier: '',
        card_number: '',
      },
    }
  },
  methods: {
    formatter(value) {
      return value.toUpperCase()
    },
    isEmpty (value) {
      return _.isEmpty(value)
    },
    hideModal () {
      this.$refs['reatribute-kanban'].hide()
    },
    showModal () {
      this.cleanForm()
      this.$refs['reatribute-kanban'].show()
    },
    save () {
      this.loading = true
      this.form.card_number = this.card
      server.attributionKanbanUpdate(this.office, this.form).then(res => {
        this.$toasted.success('Carte kanban modifiée!')
        this.hideModal()
        this.loading = false
        this.cleanForm()
      }).catch((error) => {
        this.$toasted.error(`Une erreur est survenue. Veuillez réessayer plus tard <br> ${error}`)
      })
    },
    cleanForm () {
      this.form.internal_customer = ''
      this.form.internal_supplier = ''
      this.form.card_number = ''
    },

  },
  mounted: function() {
  },
};
</script>

<style>
input.invalid {
  background-color: #ffdddd;
}

select.invalid {
  background-color: #ffdddd;
}


.step {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbbbbb;
  border: none;
  border-radius: 50%;
  display: inline-block;
  opacity: 0.5;
}

.step.active {
  opacity: 1;
}

.step.finish {
  background-color: #4CAF50;
}

</style>


// WEBPACK FOOTER //
// ReatributionFormModal.vue?f4d295a0